// Vaqtinchalik demo. Backend haqiqiy rollarni qaytara boshlaganda o'chiriladi.
//
// Test akkauntlar backend'da oddiy "admin" roli bilan yaratiladi. Kirgan foydalanuvchining telefoni
// (GET /management/staff/profile → phone_number) shu xaritada bo'lsa, unga rol kabineti ko'rsatiladi.
// +998900000002 xaritada yo'q — u oddiy admin bo'lib ishlaydi.

export const DEMO_ROLE_KEY = 'ui_demo_role';

export const DEMO_ACCOUNTS = {
  '+998900000001': 'director',
  '+998900000003': 'head_of_department',
  '+998900000004': 'registrar',
  '+998900000005': 'methodist',
  '+998900000006': 'editor',
  '+998900000007': 'qc_expert',
  '+998900000008': 'proctor',
  '+998900000009': 'curator',
  '+998900000010': 'admissions',
  '+998900000011': 'finance',
  '+998900000012': 'chief_accountant',
  '+998900000013': 'internal_control',
  '+998900000014': 'corporate_hr',
};

const DEMO_ROLES = new Set(Object.values(DEMO_ACCOUNTS));

// "+998 90 000 00 01", "998900000001", "0099890…", "90-000-00-01" → "+998900000001"; boshqasi → null
export function normalizePhone(value) {
  let digits = String(value ?? '').replace(/\D/g, '');
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (digits.length === 9) digits = `998${digits}`;
  return /^998\d{9}$/.test(digits) ? `+${digits}` : null;
}

// Xarita faqat backend roli "admin" bo'lganda ishlaydi (super_admin, mentor va boshqalar uchun — null)
export function demoRoleFor(backendRole, phone) {
  if (backendRole !== 'admin') return null;
  const normalized = normalizePhone(phone);
  return (normalized && DEMO_ACCOUNTS[normalized]) || null;
}

export function readDemoRole(backendRole) {
  if (backendRole !== 'admin') return null;
  try {
    const value = window.localStorage.getItem(DEMO_ROLE_KEY);
    return DEMO_ROLES.has(value) ? value : null;
  } catch {
    return null;
  }
}

export function saveDemoRole(code) {
  try {
    window.localStorage.setItem(DEMO_ROLE_KEY, code);
  } catch {
    // localStorage yopiq bo'lsa — demo rol faqat shu sessiyada (state'da) qoladi
  }
}

export function clearDemoRole() {
  try {
    window.localStorage.removeItem(DEMO_ROLE_KEY);
  } catch {
    // e'tiborsiz
  }
}
